import React, {CSSProperties, useRef} from 'react';
import {StickerInterface} from '../../types';
import StickerThumbnail from './StickerThumbnail';

type StickerListProps = {
  stickers: StickerInterface[];
  orientation: 'vertical' | 'horizontal';
  columns: number;
  visible: boolean;
  columnGap?: number;
  onClick: (stickerAsset: StickerInterface) => void;
};

const StickersList = ({
  stickers,
  orientation,
  columns,
  visible,
  columnGap,
  onClick,
}: StickerListProps) => {
  // Tailwind classes for the UL
  const thumbnailListClasses = [
    'flex',
    'w-[calc(100%+var(--gap))]',
    'self-start',
    'items-start',
    'flex-wrap',
    '-mt-[var(--gap)]',
    '-ml-[var(--gap)]',
  ];

  const stickersListRef = useRef<HTMLUListElement>(null);

  // stickersListRef.current?.style.setProperty('--column-gap', columnGap + 'rem');
  const cssProperties = {'--columns': columns, '--gap': columnGap + 'rem'};

  if (!visible) {
    return <></>;
  }

  return (
    <ul
      className={thumbnailListClasses.join(' ')}
      ref={stickersListRef}
      style={cssProperties as CSSProperties}
    >
      {stickers &&
        stickers.map((sticker: StickerInterface, index: number) => {
          return (
            <StickerThumbnail
              sticker={sticker}
              key={`sticker-${sticker.assetRef}-${index}`}
              columns={columns}
              columnGap={columnGap}
              onClick={onClick}
            />
          );
        })}
    </ul>
  );
};

export default StickersList;
